import React from "react";

import "./tools.css";

export default class Tools extends React.Component {
  render() {
    const {
      penMode,
      isMirrored,
      onPenSwitch,
      onMirrorToggle,
      onUndo,
      onRedo,
      onZoomIn,
      onZoomOut,
      onDarken,
      onLighten,
      onSkinReset,
    } = this.props;

    return (
      <div className="toolbar">
        <ul className="d-none d-md-block">
          <li>
            <span
              className={`btn btn-tools ${penMode === "pen" ? "active" : ""}`}
              onClick={() => onPenSwitch("pen")}
            >
              <img src="/assets/pencil.svg" alt="pen" />
            </span>
          </li>

          <li>
            <span
              className={`btn btn-tools ${penMode === "eraser" ? "active" : ""
                }`}
              onClick={() => onPenSwitch("eraser")}
            >
              <img src="/assets/eraser.svg" alt="eraser" />
            </span>
          </li>

          <li>
            <span
              className={`btn btn-tools ${penMode === "autotone" ? "active" : ""
                }`}
              onClick={() => onPenSwitch("autotone")}
            >
              <img src="/assets/icon-brush.svg" alt="autotone" />
            </span>
          </li>

          <li>
            <span
              className={`btn btn-tools ${penMode === "picker" ? "active" : ""
                }`}
              onClick={() => onPenSwitch("picker")}
            >
              <img src="/assets/color_picker.svg" alt="color picker" />
            </span>
          </li>

          <li>
            <span
              className={`btn btn-tools ${penMode === "bucket" ? "active" : ""
                }`}
              onClick={() => onPenSwitch("bucket")}
            >
              <img src="/assets/bucket_tool.svg" alt="bucket" />
            </span>
          </li>

          <li className="d-flex">
            <span className="btn mr-1" onClick={onUndo}>
              <img src="/assets/undo.svg" alt="undo" />
            </span>
            <span className="btn" onClick={onRedo}>
              <img src="/assets/redo.svg" alt="redo" />
            </span>
          </li>

          <li className="d-flex">
            <span className="btn mr-1" onClick={onDarken}>
              <img src="/assets/darken.svg" alt="darken" />
            </span>
            <span className="btn" onClick={onLighten}>
              <img src="/assets/lighten.svg" alt="lighten" />
            </span>
          </li>

          <li className="d-flex">
            <span className="btn mr-1" onClick={onZoomIn}>
              <img src="/assets/zoom_in.svg" alt="zoom_in" />
            </span>
            <span className="btn" onClick={onZoomOut}>
              <img src="/assets/zoom_out.svg" alt="zoom_out" />
            </span>
          </li>

          <li>
            <span
              className={`btn btn-tools mirror ${isMirrored ? "active" : ""}`}
              onClick={() => onMirrorToggle()} >
              <img src="/assets/mirror.svg" alt="mirror" />
            </span>
          </li>

          <li>
            <span className="btn-reset" onClick={onSkinReset}>
              Reset
            </span>
          </li>
        </ul>

        <div className="d-md-none toolbar-sp">
          <div>
            <span
              className={`btn btn-tools mirror ${isMirrored ? "active" : ""}`}
              onClick={() => onMirrorToggle()} >
              <img src="/assets/mirror.svg" alt="mirror" />
            </span>
          </div>

          <ul>
            <li className="d-flex">
              <span
                className={`btn btn-tools ${penMode === "pen" ? "active" : ""}`}
                onClick={() => onPenSwitch("pen")} >
                <img style={{ marginLeft: "-14px" }} src="/assets/pencil.svg" alt="pen" />
              </span>

              <span
                className={`btn btn-tools ${penMode === "eraser" ? "active" : ""
                  }`}
                onClick={() => onPenSwitch("eraser")} >
                <img src="/assets/eraser.svg" alt="eraser" />
              </span>

              <span
                className={`btn btn-tools ${penMode === "autotone" ? "active" : ""
                  }`}
                onClick={() => onPenSwitch("autotone")}  >
                <img src="/assets/icon-brush.svg" alt="autotone" />
              </span>

              <span
                className={`btn btn-tools ${penMode === "picker" ? "active" : ""
                  }`}
                onClick={() => onPenSwitch("picker")}  >
                <img src="/assets/color_picker.svg" alt="color picker" />
              </span>

              <span className="btn btn-tools" onClick={onZoomIn}>
                <img style={{ marginLeft: "-3px" }} src="/assets/zoom_in.svg" alt="zoom_in" />
              </span>

              <span
                className={`btn btn-tools ${penMode === "bucket" ? "active" : ""
                  }`}
                onClick={() => onPenSwitch("bucket")} >
                <img src="/assets/bucket_tool.svg" alt="bucket" />
              </span>
            </li>
            <li className="d-flex">
              <span className="btn btn-fix" onClick={onUndo}>
                <img src="/assets/undo.svg" alt="undo" />
              </span>
              <span className="btn btn-fix" onClick={onRedo}>
                <img src="/assets/redo.svg" alt="redo" />
              </span>
              <span className="btn btn-fix" onClick={onDarken}>
                <img src="/assets/darken.svg" alt="darken" />
              </span>
              <span className="btn btn-fix" onClick={onLighten}>
                <img src="/assets/lighten.svg" alt="lighten" />
              </span>
              <span className="btn btn-tools" onClick={onZoomOut}>
                <img style={{ marginLeft: "-3px" }} src="/assets/zoom_out.svg" alt="zoom_out" />
              </span>
              <span className="btn-reset" onClick={onSkinReset}>
                Reset
              </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
